'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var amber = {};

exports.__exports = amber;
